import qs from 'qs';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ProductFeatureName } from 'dashboard/models/organization';
import { AvailableOrganizationPlan } from 'dashboard/models/organization-plan';
import { OrganizationPlanMigration } from 'dashboard/models/organization-plan-migration';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel, ApiSingletonPayload } from 'lib/interfaces/api';

export function createOrganizationPlanMigration(
  inquiryId: string,
  requestedPlanKey: string,
): DashboardThunkAction<Promise<{ organizationPlanMigration: OrganizationPlanMigration }>> {
  return async () => {
    const { data: organizationPlanMigration } = await SessionClientDashboard.postResourceCreate<
      OrganizationPlanMigration,
      ApiSingletonPayload<{
        'inquiry-id': string;
        'requested-plan-key': string;
      }>
    >({
      type: ApiModel.OrganizationPlanMigration,
      attributes: {
        'inquiry-id': inquiryId,
        'requested-plan-key': requestedPlanKey,
      },
    });

    return { organizationPlanMigration };
  };
}

export function loadAvailablePlans(
  requiredProductFeatures: ProductFeatureName[],
): DashboardThunkAction<Promise<AvailableOrganizationPlan[]>> {
  return async () => {
    const params = {
      required_product_features: requiredProductFeatures,
    };

    const response = await SessionClientDashboard.getResourceMeta<{
      'available-plans': AvailableOrganizationPlan[];
    }>(
      ApiEndpoint.OrganizationPlan,
      `available-plans?${qs.stringify(params, { arrayFormat: 'brackets' })}`,
    );

    return response?.meta?.['available-plans'] ?? [];
  };
}
